import { memo, useCallback, useMemo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteOffer } from 'modules/sales-offer/offer/hooks/useDeleteOffer';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { IOffer } from '../../interfaces';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';
import { getOfferOrderStatus } from '../OfferStatus/OfferStatus';
import { useNavigate } from 'react-router';
import { IconButton } from '@dfl/mui-react-common';
import { AnalyticTabIcon } from 'components/libs/Icons/tabs';
import { useTranslation } from 'react-i18next';
import { disabledOfferReport, disabledCloneOffer } from 'utils/flags-utils';
import OfferCloneButton from '../OfferCloneButton/OfferCloneButton';

type Props = {
  data: IOffer;
};

const OfferRowActions = ({ data }: Props) => {
  const { t } = useTranslation('offers');
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isPending, error } = useDeleteOffer(data?._id as string, onClose);
  const status = useMemo(() => getOfferOrderStatus(data?.fromDate, data?.toDate), [data?.fromDate, data?.toDate]);

  const navigate = useNavigate();

  const handleEdit = useCallback(() => {
    navigate(`/sales/offers/settings/offer_orders/${data?._id as string}/general/?edit=true`);
  }, [navigate, data?._id]);

  const handleReport = useCallback(() => {
    navigate(`/sales/offers/settings/offer_orders/${data?._id as string}/analytic`);
  }, [navigate, data?._id]);

  return (
    <>
      <Stack direction='row' spacing={1}>
        <EditRowActions onClick={handleEdit} />
        {!disabledCloneOffer && <OfferCloneButton offerId={data?._id as string} iconButton />}
        {!disabledOfferReport &&
          <IconButton tooltip={t('report.title')} onClick={handleReport}>
            <AnalyticTabIcon fontSize='small' color='primary' />
          </IconButton>
        }
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          disabled={status === OFFER_STATUS.ACTIVE}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
        />
      </Stack>
    </>
  );
};

export default memo(OfferRowActions);
